import { useMutation } from "react-relay"
import { graphql } from "relay-runtime"
import { chCreateDoctorNetworkMutation as TMutation } from "@/modules/patients/services/ch/__generated__/chCreateDoctorNetworkMutation.graphql"

export const chCreateDoctorNetworkMutation = graphql`
  mutation chCreateDoctorNetworkMutation($input: Ch_createDoctorNetworkInput!) {
    createDoctorNetwork: ch_createDoctorNetwork(input: $input) {
      doctorNetwork {
        createdAt
        patientId
        role
      }
    }
  }
`

export const useChCreateDoctorNetworkMutation = () => {
  return useMutation<TMutation>(chCreateDoctorNetworkMutation)
}
